import { Reveal } from "@/components/Reveal";
import { Target, ShieldCheck, Globe2, Handshake } from "lucide-react";
import { siteConfig } from "@/data/siteConfig";

const icons = [Target, ShieldCheck, Globe2, Handshake];

export function TrustCards() {
  return (
    <section className="relative -mt-px border-y border-[#E3E8EF] bg-white" data-testid="trust-cards">
      <div className="mx-auto grid max-w-7xl grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        {siteConfig.trust.map((t, i) => {
          const Icon = icons[i];
          return (
            <Reveal key={t.title} delay={i * 0.08}
              className="group border-[#E3E8EF] p-8 lg:p-10 border-b sm:[&:nth-child(odd)]:border-r lg:border-r lg:last:border-r-0 transition-colors duration-300 hover:bg-canvas">
              <Icon className="w-8 h-8 text-ink group-hover:text-amber-hover transition-colors duration-300" strokeWidth={1.5} />
              <h3 className="mt-5 font-display uppercase text-xl tracking-wide text-ink">{t.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted">{t.desc}</p>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
